<div style="height: 8px; background-color: rgba(16, 46, 94, 0.982)" class="col-12"></div>
<h2 class="mb-0" mat-dialog-title>{{ this.data ? "Répondre à une demande d'avis" : "Création d'une demande d'avis" }}
</h2>
<button mat-dialog-close style="position: absolute; top: 10px; right: 10px" mat-icon-button>
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content style="color: inherit">
  <div [formGroup]="form" style="display: flex; flex-direction: column; gap: 10px">
    <label for="destinataire" class="label">Destinataire *</label>
    <div class="form-text mb-1">Sélectionnez le destinataire.</div>
    <mat-form-field style="margin-bottom: -1.25em; width: 100%" floatLabel="always">
      <input #autoCompleteAgent type="text" aria-label="Nom Prénom" placeholder="Filtrer par destinataire" matInput
        name="item" [matAutocomplete]="auto" formControlName="destinataire" (input)="agentFilter($event)" />

        @if (this.form.get('destinataire')?.value && !this.form.get('destinataire')?.disabled) {
          <button matSuffix
            mat-icon-button aria-label="Clear" (click)="effaceAgentFiltreRecrutement($event)">
            <mat-icon>close</mat-icon>
          </button>
        }
        <mat-autocomplete ngDefaultControl cdkScrollable #auto="matAutocomplete" hideSingleSelectionIndicator="true"
          [displayWith]="agentdisplayFnRecrutement">
          @for (agent of filteredAgents; track agent) {
            <mat-option [value]="agent"> {{ agent.nom }} {{ agent.prenom }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (form.get('destinataire')?.invalid && form.get('destinataire')?.touched) {
          <mat-error>Le destinataire est
          obligatoire</mat-error>
        }
      </mat-form-field>

      <label for="note" class="label pt-2">Note *</label>
      <div class="form-text mb-1">Saisissez une note.</div>
      <mat-form-field>
        <textarea matInput formControlName="note" rows="3"></textarea>
        @if (form.get('note')?.invalid || form.get('note')?.hasError('whitespace') && form.get('note')?.touched) {
          <mat-error
            >Ce
          champ ne peut pas être vide ou contenir uniquement des espaces.</mat-error>
        }
      </mat-form-field>

      @if (data) {
        <label class="label pt-2">Pièces jointes</label>
        <div class="form-text mb-1">Vous pouvez joindre des fichiers à votre demande d'avis.</div>
        <app-file-control [control]="form.get('files')!" [label]="'Glissez-déposez les fichiers ici'"
          [buttonText]="'Ou cliquez ici pour sélectionner les fichiers'" [requiredErrorMessage]="''"
        [showSizeWarning]="true" [acceptLabel]="'PDF'" [maxFileSizeMB]="300"></app-file-control>
      }
    </div>
  </mat-dialog-content>

  <mat-divider></mat-divider>
  <mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]="null" style="width: 80px; padding-right: 10px">Annuler</button>
    <button mat-flat-button color="primary" style="width: 80px" cdkFocusInitial (click)="onSubmit()">Valider</button>
  </mat-dialog-actions>